<template>
  <div>
    <el-select v-model="selectValue" placeholder="请选择" @change="selectProduct" class="select">
      <el-option v-for="item in bgOptions" :key="item.value" :label="item.label" :value="item.value" :filterable="true" />
    </el-select>
    <el-upload action="/exhibit/uploadPicture" name="picture" :multiple="true" list-type="picture-card"
      :before-upload="beforeUpload" :file-list="fileList" :on-success="handlesucess"
      :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-error="handleError">
      <i class="el-icon-plus"></i>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
    <el-button class="bg-fix-btn" size="small" type="primary" @click="submitimg" v-if="hasFix">确认修改轮播图</el-button>
  </div>
</template>
<script>
import { exhibitCarouselPictures, exhibitCarouselPicturesByCategory, updateCarouselPictures } from '@/api/exhibitPicture.js';
import { deletePicture } from '@/api/Picture.js';
import { exhibitTopCategory, exhibitTopCarouselPictures } from '@/api/exhibitTop.js'
import { domain } from '@/utils/state'
export default {
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      fileList: [],   //图片列表
      fileLists: [],  //图片路径列表
      selectValue: null,
      hasFix: false,
      bgOptions: [],
      domain: domain
    };
  },
  methods: {
    // 选择产品
    showPic(res) {
      let pictureList = [];
      this.fileLists = res.map(item => {
        return item.pictureSrc
      })
      for (let i = 0; i < res.length; i++) {
        pictureList.push(res[i].pictureSrc);
      }
      this.fileList = pictureList.map(item => {
        return {
          name: item,
          url: domain + '/' +item // 这里修改
        }
      });
    },
    async selectProduct(targetVal) {
      this.selectValue = targetVal
      this.hasFix = false
      if (this.selectValue) {
        await exhibitCarouselPicturesByCategory({ parentId: this.selectValue, categoryId: this.selectValue }).then(res => {
          this.showPic(res)
        })
      } else {
        await exhibitTopCarouselPictures().then(res => {
          this.showPic(res)
        })
      }
    },
    beforeUpload(file) {
      console.log(file)
    },
    handleRemove(file, fileList) {
      let pictureList = []
      console.log(file, fileList);
      this.fileList = fileList;
      for (let i = 0; i < this.fileList.length; i++) {
        pictureList.push(this.fileList[i].name);
      }
      this.fileLists = pictureList;
      let url = file.url;

      deletePicture({ pictureSrc: url, parentId: this.selectValue }).then(res => {
        this.hasFix = true
        this.$message({
          message: '删除成功',
          type: 'success'
        });
      })
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handlesucess(response, file, fileList) {
      console.log(response);
      let img = {
        name: response,
        url: response
      }
      this.fileList.push(img),
      this.fileLists.push(response)
      this.hasFix = true
    },
    submitimg() {
      let url = '/exhibitPicture/updateCarouselPictures'
      if (this.selectValue) {
        url += `?categoryId=${this.selectValue}`
      }
      console.log(this.fileLists);
      updateCarouselPictures({strings: this.fileLists}, url).then(res => {
        this.$message({
          message: '修改成功',
          type: 'success'
        });
        this.hasFix = false
      })
    },
    handleError(err, file, fileList) {
      console.log(err, file, fileList)
    }

  },
  async created() {
    await exhibitTopCategory().then((res) => {
      this.bgOptions = res.map(item => ({
        label: item.title,
        value: item.categoryId
      }))
      this.bgOptions.unshift({
        value: null,
        label: '首页'
      })
      this.selectValue = null
    })

    await exhibitTopCarouselPictures().then(res => {
      this.showPic(res)
    })
  }
};
</script>
<style>
.select {
  margin-bottom: 20px;
}
.bg-fix-btn {
  margin-top: 2vh;
}
</style>